
import React from "react";
import { Grid, List, Search, X } from "lucide-react";
import { Input } from "../ui/input";

interface SearchAndViewOptionsProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  viewMode: "grid" | "list";
  setViewMode: (mode: "grid" | "list") => void;
}

const SearchAndViewOptions: React.FC<SearchAndViewOptionsProps> = ({
  searchQuery,
  setSearchQuery,
  viewMode,
  setViewMode
}) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="relative w-full sm:w-auto">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search components..."
          className="pl-9 w-full sm:w-[250px] bg-black/50 border-white/10 focus:border-primary/40 rounded-md"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground hover:text-foreground"
          >
            <X size={16} />
          </button>
        )}
      </div>
      <div className="border border-white/10 rounded-md flex bg-black/50 overflow-hidden">
        <button
          onClick={() => setViewMode("grid")}
          className={`p-2 transition-colors ${viewMode === "grid" ? "bg-primary/20 text-primary" : "hover:bg-white/5 text-muted-foreground hover:text-foreground"}`}
          title="Grid view"
        >
          <Grid size={18} />
        </button>
        <button
          onClick={() => setViewMode("list")}
          className={`p-2 transition-colors ${viewMode === "list" ? "bg-primary/20 text-primary" : "hover:bg-white/5 text-muted-foreground hover:text-foreground"}`}
          title="List view"
        >
          <List size={18} />
        </button>
      </div>
    </div>
  );
};

export default SearchAndViewOptions;
